document.addEventListener("DOMContentLoaded", function () {
  const itemPrices = new Map(); // To store item prices mapped by their corresponding .line-item

  function updateFormattedTotalPrice() {
    const cartDrawerItems = document.querySelectorAll('.cart-drawer__line-items .line-item');
    const priceChangeElement = document.querySelector('.cstm-price-change');
    const cartTotalElement = document.querySelector('.cstm-cart-total');
    const discountElement = document.querySelector('.cstm-cart-discount');

    if (cartDrawerItems && priceChangeElement && cartTotalElement && discountElement) {
      const total = Array.from(cartDrawerItems).reduce((sum, lineItem) => {
        const updatedPriceElement = lineItem.querySelector('.cstm-cart-pro-price-update');
        const updatedPrice = parseFloat(
          updatedPriceElement?.innerHTML.trim().replace(/[^\d,.-]+/g, '').replace(',', '.')
        );
        return sum + (updatedPrice || 0);
      }, 0);

      const firstPriceElement = cartDrawerItems[0]?.querySelector('.cstm-price-get');
      const firstPrice = firstPriceElement?.innerHTML.trim() || '';
      const detectedCurrencySymbol = firstPrice.match(/[^\d\s,.]+/)?.[0] || '';
      const detectedCurrencyCode = firstPrice.match(/[A-Za-z]{3}/)?.[0] || 'USD';

      const isValidCurrency = (currencyCode) => {
        try {
          new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(100);
          return true;
        } catch {
          return false;
        }
      };

      const currency = isValidCurrency(detectedCurrencyCode) ? detectedCurrencyCode : 'USD';

      // Format total with correct decimal places and maintain currency symbol
      const formattedTotal = total.toFixed(2); // Always show 2 decimals for total

      // Update .cstm-price-change with proper formatted price
      priceChangeElement.innerHTML = `${detectedCurrencySymbol}${formattedTotal}`;

      const cartTotal = parseFloat(
        cartTotalElement.innerHTML.trim().replace(/[^\d,.-]+/g, '').replace(',', '.')
      ) || 0;

      const discount = total - cartTotal;
      const formattedDiscount = discount.toFixed(2);

      discountElement.innerHTML = `${detectedCurrencySymbol}${formattedDiscount}`;
    } else {
      console.error('Elements not found');
    }
  }

  function updateLineItems() {
    const lineItems = document.querySelectorAll('.cart-drawer__line-items .line-item');

    lineItems.forEach((lineItem) => {
      const priceElement = lineItem.querySelector('.cstm-price-get');
      const quantityInput = lineItem.querySelector('.line-item__actions .quantity-input');
      const priceUpdateElement = lineItem.querySelector('.cstm-cart-pro-price-update');

      if (!priceElement || !quantityInput || !priceUpdateElement) {
        console.error('Missing elements in line item');
        return;
      }

      if (!itemPrices.has(lineItem)) {
        const priceText = priceElement.innerHTML.trim();
        const price = parseFloat(priceText.replace(/[^\d,.-]+/g, '').replace(',', '.'));
        const currencySymbol = priceText.match(/[^\d\s,.]+/)?.[0] || '';

        itemPrices.set(lineItem, { price, currencySymbol }); // Store both price and currency symbol
      }

      const { price: basePrice, currencySymbol } = itemPrices.get(lineItem);
      const quantity = parseInt(quantityInput.value, 10) || 0;
      const totalPrice = basePrice * quantity;

      // Ensure the price is displayed correctly with two decimal places
      priceUpdateElement.innerHTML = `${currencySymbol}${totalPrice.toFixed(2)}`;

      quantityInput.addEventListener('input', () => {
        const updatedQuantity = parseInt(quantityInput.value, 10) || 0;
        const updatedTotalPrice = basePrice * updatedQuantity;

        // Ensure the updated price maintains the proper format
        priceUpdateElement.innerHTML = `${currencySymbol}${updatedTotalPrice.toFixed(2)}`;
      });
    });
  }

  setInterval(() => {
    updateLineItems();
    updateFormattedTotalPrice();
  }, 1000);
});
